import { pick } from "lodash-es";

import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { getAppliedMapFiltersCount } from "@app/component/filtering/components/filterButtons/MapFilterPopover/utils/getAppliedMapFiltersCount";
import { cleanUpMapFilterModel } from "@app/component/filtering/utils/cleanUpMapFilterModel";
import universalFieldsFieldModel, {
  UniversalFieldName,
} from "@app/util/fieldModel/universalFieldsFieldModel";

interface IsMapFilterAppliedOptions {
  implicitFields: UniversalFieldName[]; // Universal fields that are scope on this screen, not the rep's filter.
  visibleTypes: EntityTypesSupportedByMapsPage[]; // Only these types' filters reach the request, so only they count.
}

const isMapFilterApplied = (
  filter: MapFilterModel,
  { implicitFields, visibleTypes }: IsMapFilterAppliedOptions
): boolean => {
  const fields = implicitFields.flatMap((name) => universalFieldsFieldModel.getByName(name) ?? []);
  const sent: MapFilterModel = pick(filter, ["universal", ...visibleTypes]);
  return getAppliedMapFiltersCount(cleanUpMapFilterModel(sent), fields) > 0;
};

export default isMapFilterApplied;
